import { AppSportsBookState } from 'src/domains/sportsbook/state/AppSportsBook.state';
import React, { useState } from 'react';
import { SelectionItemStyle } from './SelectionRaceCard.style';
import { observer } from 'src/utils/mobx-react';
import { SelectionRaceCardState } from './SelectionRaceCard.state';
// eslint-disable-next-line no-restricted-imports
import { useAsObservableSource } from 'mobx-react-lite';
import { SelectionId } from 'src_common/common/websocket2/id/WebsocketId';
import { useCommon } from 'src/domains/common/Common';
import { ConfigComponents } from 'src/domains/layouts/config/features/config';
import { BasicDataModel } from 'src/domains/players/state/BasicDataModel';
import { StarRouter } from 'src/domains/layouts/state/router/StarRouter';

interface PropsType {
    borderBottom?: boolean;
    borderLeft?: boolean;
    borderRight?: boolean;
    borderTop?: boolean;
    isPriceBoostActive?: boolean;
    isRacingPage: boolean;
    selectionId: SelectionId | undefined;
    sp?: boolean;
    useBoostedPrice?: boolean;
}

export const SelectionRaceCard = observer('SelectionRaceCard', (propsIn: PropsType) => {
    const props = useAsObservableSource(propsIn);
    const { borderTop, borderRight, borderBottom, borderLeft, isPriceBoostActive } = props;
    const isDisabled = isPriceBoostActive === true;
    const common = useCommon();

    const appSportsBookState = AppSportsBookState.get(common);
    const { betSlipState } = appSportsBookState;

    const configState = ConfigComponents.get(common).config;
    const { basicData } = BasicDataModel.get(common);
    const starRouter = StarRouter.get(common);

    const [state] = useState(() => new SelectionRaceCardState(betSlipState, starRouter, props, basicData));

    if (state.selectionView === null) {
        const selectionId: string | number | undefined =
            props.sp === true ? `sp-${props.selectionId?.toOldId() ?? 'id-undefined'}` : props.selectionId?.toOldId();

        return (
            <SelectionItemStyle
                href='#'
                data-test-selection-id={selectionId}
                onClick={isDisabled ? undefined : state.chooseNew}
                isDisabled={isDisabled}
                borderBottom={borderBottom}
                borderLeft={borderLeft}
                borderRight={false}
                borderTop={borderTop}
                variant={configState.componentVariants.sportsbookVariant}
            >
                -
            </SelectionItemStyle>
        );
    }

    const { priceChange, suspended, price } = state.selectionView;
    const isEmpty = price === undefined;

    const selectionId: string | number | undefined =
        props.sp === true ? `sp-${props.selectionId?.toOldId() ?? 'id-undefined'}` : props.selectionId?.toOldId();

    return (
        <SelectionItemStyle
            borderBottom={borderBottom}
            borderLeft={borderLeft}
            borderRight={borderRight}
            borderTop={borderTop}
            data-test-selection-id={selectionId}
            href='#'
            isDisabled={isDisabled}
            isEmpty={isEmpty}
            isOddsDown={priceChange === 'down'}
            isOddsUp={priceChange === 'up'}
            isSelected={isDisabled ? false : state.isSelected}
            isSuspended={suspended}
            onClick={isDisabled ? undefined : state.chooseNew}
            variant={configState.componentVariants.sportsbookVariant}
        >
            {state.getOddsValue}
        </SelectionItemStyle>
    );
});
